import { render } from "./BaseInfoForm.vue?vue&type=template&id=e6559298"
import script from "./BaseInfoForm.vue?vue&type=script&lang=js"
export * from "./BaseInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__